import React from 'react';
import { Brain, HeartCrack, UserX, Eye, BatteryWarning } from 'lucide-react';
export function AgitationSection() {
  const costs = [{
    icon: Brain,
    title: 'Concentración',
    desc: 'Errores en el trabajo'
  }, {
    icon: HeartCrack,
    title: 'Tu pareja',
    desc: 'Peleas a las 2 AM'
  }, {
    icon: UserX,
    title: 'Tu identidad',
    desc: 'Ya no recordás cómo eras'
  }, {
    icon: Eye,
    title: 'Tu imagen',
    desc: 'Ojeras permanentes'
  }, {
    icon: BatteryWarning,
    title: 'Tu energía',
    desc: 'Agotamiento constante'
  }];
  return <section className="py-12 md:py-16 bg-warm-100" data-id="element-18">
      <div className="max-w-4xl mx-auto px-4" data-id="element-19">
        <div className="text-center mb-8" data-id="element-20">
          <h2 className="text-2xl md:text-3xl font-bold text-text-dark mb-2" data-id="element-21">
            Lo que el cansancio te está cobrando
          </h2>
          <p className="text-text-muted" data-id="element-22">Sin que lo notes</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-10" data-id="element-23">
          {costs.map((cost, idx) => {
          const Icon = cost.icon;
          return <div key={idx} className="bg-white p-4 rounded-xl shadow-sm text-center" data-id="element-24">
                <div className="bg-primary-50 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-25">
                  <Icon className="w-5 h-5 text-primary-500" data-id="element-26" />
                </div>
                <h3 className="font-semibold text-text-dark text-sm mb-1" data-id="element-27">
                  {cost.title}
                </h3>
                <p className="text-xs text-text-muted" data-id="element-28">{cost.desc}</p>
              </div>;
        })}
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-md border-l-4 border-primary-500" data-id="element-29">
          <p className="text-text-body leading-relaxed" data-id="element-30">
            Sabés que no podés rendirte. Que mañana toca levantarse igual.
            Mientras tanto, ves papás que sí duermen y te preguntás:{' '}
            <em className="text-text-dark font-medium" data-id="element-31">
              ¿qué están haciendo diferente?
            </em>
          </p>
        </div>
      </div>
    </section>;
}